import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { Typography } from 'antd'
import { ColourButton } from 'portal/lib/primitives'
import { PageContainer } from 'portal/pages/PageContainer'

export const Forbidden = (): JSX.Element => {
  const navigate = useNavigate()

  const { Title } = Typography
  return (
    <Container limitWidth>
      <Title
        level={3}
        style={{ wordSpacing: '2px', lineHeight: '1.5', textAlign: 'center' }}
      >
        Your Qflow access level doesn't include this page,
        <br />
        or you do not have any records assigned to you.
      </Title>
      <p>
        Looking for records assigned to you? View our{' '}
        <a
          href="https://qualisflowhelp.zendesk.com/hc/en-gb"
          target="_blank"
          rel="noreferrer noopener"
        >
          support library
        </a>{' '}
        to learn why you're seeing this page.
      </p>
      <p>
        For assistance with your access rights, please contact your account
        administrator or email us at{' '}
        <a href="mailto:support@qualisflow.com">support@qualisflow.com</a>.
      </p>
      <Button id="forbiddenBackBtn" onClick={() => navigate(-2)}>
        Go Back
      </Button>
    </Container>
  )
}

const Container = styled(PageContainer)`
  align-items: center;
  margin-top: 4rem;
`

const Button = styled(ColourButton.Action)`
  margin-top: 3rem;

  min-width: 4rem;
  width: 25%;
  max-width: 15rem;
`
